import { InputAdornment } from '@material-ui/core'
import { AttachMoney } from '@material-ui/icons'

export const ComprobantesFields = (data) => {
  return [
    {
      label: 'Saldo recibo',
      class: 'textfield',
      value: data.total,
      sm: 6,
      xs: 12,
      disabled: true,
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
    },
    {
      label: 'Total a imputar',
      class: 'textfield',
      value: data.id,
      sm: 6,
      xs: 12,
      disabled: true,
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
    },
  ]
}
